var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenManagementActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.72397H22V17.7222C22 18.5711 21.7029 19.2925 21.1087 19.8865C20.5147 20.4807 19.7933 20.7778 18.9444 20.7778H3.05556C2.20672 20.7778 1.48531 20.4807 0.891306 19.8865C0.297102 19.2925 0 18.5711 0 17.7222V5.72397ZM2.03714 7.76111V17.7222C2.03714 18.0109 2.13471 18.2528 2.32986 18.4479C2.52501 18.6431 2.76691 18.7406 3.05556 18.7406H18.9444C19.2331 18.7406 19.475 18.6431 19.6701 18.4479C19.8653 18.2528 19.9629 18.0109 19.9629 17.7222V7.76111H2.03714ZM0 4.50175V2.44444H7.53714V1.01842C7.53714 0.729973 7.63471 0.488075 7.82986 0.292723C8.02501 0.0975746 8.26691 0 8.55556 0H13.4444C13.7331 0 13.975 0.0975746 14.1701 0.292723C14.3653 0.488075 14.4629 0.729973 14.4629 1.01842V2.44444H22V4.50175H0Z",
    fill: "#276229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenManagementActiveIcon);
export default __webpack_public_path__ + "static/media/kitchen_management_active_icon.3379287e1994563fe5eb5fcc05fe4a46.svg";
export { ForwardRef as ReactComponent };